export default {
    data() {
        return {
            foundFontFile: null
        };
    },

    async serverPrefetch() {
        if (process.server) {
            const fs = eval('require("fs")');
            const path = eval('require("path")');

            // Взять некую переменную PUBLIC_NAME, чтобы искать её как font-family
            const publicName = this.$config.PUBLIC_NAME.replace(/\./g, '');
            if (!publicName) return;

            // Путь к нашему "downloaded-fonts.scss" (или как он у вас называется)
            const rootDir = process.cwd();
            const scssFilePath = path.join(rootDir, 'assets', 'scss', 'downloaded-fonts.scss');

            // Проверяем, существует ли он
            if (fs.existsSync(scssFilePath)) {
                console.log('Ищем шрифт в SCSS-файле:', scssFilePath);

                // Считываем весь SCSS
                const scssContent = fs.readFileSync(scssFilePath, 'utf8');

                // Простой вариант: используем регулярное выражение, которое ищет
                // @font-face {... font-family: 'someName' ... }
                // Учтём, что могут быть одинарные или двойные кавычки, пробелы и т.д.
                // Пример очень общий, вы можете дополнить проверку на @font-face
                // и extract именно family.

                // Это регулярка, которая ищет:
                //   font-family: 'moods' или font-family: "moods"
                //   без учёта регистра, если нужно. Здесь предполагается, что
                //   publicName – не содержит спецсимволов с RegExp
                //   Если у вас могут быть опасные символы, экранируйте их.

                const familyRegex = new RegExp(`font-family:\\s*['"]${publicName}['"]`, 'i');

                // Ищем совпадение
                if (familyRegex.test(scssContent)) {
                    // Если нашли – значит в @font-face этот шрифт есть
                    this.foundFontFile = publicName;
                    console.log(`Шрифт "${publicName}" найден в downloaded-fonts.scss`);
                } else {
                    console.log(`Шрифт "${publicName}" не найден в downloaded-fonts.scss`);
                }
            }
        }
    }
};
